angular.module('myappointments').controller('MyAppointmentsCtrl',
    ['$scope', '$q', '$sce', '$log', 'TransitionManager', 'PatientPortalStorageRepository', 'MyAppointmentsRepository', 'MyAppointmentsService', 'NotificationService', 'toaster', 'aprgettext', 'PatientSettingsService',
        function ($scope, $q, $sce, $log, TransitionManager, PatientPortalStorageRepository, MyAppointmentsRepository, MyAppointmentsService, NotificationService, toaster, gettext, PatientSettingsService) {
            'use strict';

            $scope.loading = true;
            $scope.upcomingAppointments = [];
            $scope.previousAppointments = [];
            $scope.pendingAppointment = null;
            $scope.fullAppointmentDescription = false;
            $scope.limitTo = 120;

            $scope.searchFilter = {
                StartDate: '1/1/1800',
                EndDate: '12/31/9999',
                SortDirection: 'desc',
                FetchLimit: 250
            };

            var featureList = PatientSettingsService.getPatientFeatures();
            $scope.canRequestAppointments = featureList.RequestAppointments.IsActive;
            $scope.canViewAppointments = featureList.ViewAppointments.IsActive;
            $scope.canCheckInFeature = featureList.CheckIn.IsActive;
            featureList = null;

            var activePatient = PatientPortalStorageRepository.getActivePatient();

            function isUpcomingAppointment(appointmentDateTime, minUpcomingAppointmentDateTime) {
                if (!appointmentDateTime) {
                    return false;
                }

                var diff = moment(appointmentDateTime).diff(moment(minUpcomingAppointmentDateTime), 'days');
                return (diff >= 0);
            }

            function createAppointmentLists(appointments) {
                var minUpcomingAppointmentDateTime = moment().subtract(1, 'hours');
                var appointmentLists = _.partition(appointments, function (item) {
                    return isUpcomingAppointment(item.StartDateTime, minUpcomingAppointmentDateTime);
                });

                $scope.upcomingAppointments = _(appointmentLists[0])
                    .map(function(property){
                        return _.assignIn(property , { mapLoaded: false, fullAppointmentDescription: false });
                    })
                    .sortBy('StartDateTime')
                    .forEach(function (item) {
                        item.CanReschedule = false;

                        // Can check in 1 hour early to 1 hour late
                        // Appointment Status cannot be Canceled, Discharged or Checked In
                        item.CanCheckIn = false;
                        if (moment(item.StartDateTime).isBetween(moment().subtract(1, 'hours'), moment().add(1, 'hours'))) {
                            if ( !(MyAppointmentsService.isCheckIn(item.AppointmentStatus.Id) || MyAppointmentsService.isCancled(item.AppointmentStatus.Id) || MyAppointmentsService.isDischarged(item.AppointmentStatus.Id)) )  {
                                item.CanCheckIn = true;
                            }
                        }
                        item.CanCancel = !(MyAppointmentsService.isCheckIn(item.AppointmentStatus.Id) || MyAppointmentsService.isCancled(item.AppointmentStatus.Id) || MyAppointmentsService.isDischarged(item.AppointmentStatus.Id));

                        item.IsAppointmentToday = false;
                        if (MyAppointmentsService.isAppointmentToday(item.StartDateTime)) {
                            item.IsAppointmentToday = true;
                        }

                    });
                
                $scope.previousAppointments = appointmentLists[1];
            }

            function getPatientAppointments(searchFilter) {
                $scope.loading = true;
                return MyAppointmentsRepository
                    .getAppointments(activePatient.id, searchFilter)
                    .then(function (data) {
                        createAppointmentLists(data);
                    })
                    .finally(function () {
                        $scope.loading = false;
                    });
            }

            function createPendingAppointments(pendingAppts) {
                if (pendingAppts) {
                    _.assignIn(pendingAppts, { mapLoaded: false });
                    $scope.pendingAppointment = pendingAppts;
                    $scope.pendingAppointment.CanReschedule = true;
                    //$log.log('pending appointment requests:');
                    //$log.log($scope.pendingAppointment);
                }
                else {
                    $scope.pendingAppointment = null;
                }
            }

            function getPendingAppointments() {
                return MyAppointmentsRepository
                    .getPendingAppointmentRequest(activePatient.id)
                    .then(function (pendingAppts) {
                        createPendingAppointments(pendingAppts);
                    });
            }
            
            function loadPage() {
                $scope.loading = true;
                $scope.removeHttpError();

                if (!$scope.canViewAppointments) {
                    toaster.pop('warning', '', gettext('The View Appointments feature is not enabled.'));
                    TransitionManager.transition({appRoute: 'dashboard'});
                    return;
                }

                activePatient = PatientPortalStorageRepository.getActivePatient();

                var pendingAppointmentsPromise = getPendingAppointments();
                var bookedAppointmentsPromise = getPatientAppointments($scope.searchFilter);
                $q.all([pendingAppointmentsPromise, bookedAppointmentsPromise]).catch(function (response) {
                    $scope.addHttpError(response);
                }).finally(function () {
                    $scope.loading = false;
                });
            }
            loadPage();

            $scope.toggleFullAppointmentDescriptionPending = function toggleFullAppointmentDescriptionPending()
            {
                $scope.fullAppointmentDescriptionPending = !$scope.fullAppointmentDescriptionPending;
            };

            $scope.toggleFullAppointmentDescription = function toggleFullAppointmentDescription(appt)
            {
                appt.fullAppointmentDescription = !appt.fullAppointmentDescription;
                console.log(appt.fullAppointmentDescription);
            };

            $scope.requestNewAppointment = function requestNewAppointment() {
                MyAppointmentsService.clearRequestedAppointment();
                TransitionManager.transition({appRoute: 'addRequestedAppointment'});
            };

            $scope.rescheduleRequestedAppointment = function rescheduleRequestedAppointment() {
                var requestedAppointment = {
                    Message: { Id: $scope.pendingAppointment.MessageId},
                    Calendar: { Id: $scope.pendingAppointment.Calendar.Id, Description: ''},
                    AppointmentType: { Id: $scope.pendingAppointment.AppointmentType.Id},
                    RequestDateTime: $scope.pendingAppointment.StartDateTime,
                    Reason: $scope.pendingAppointment.Reason
                };
                MyAppointmentsService.cacheRequestedAppointment(requestedAppointment);
                TransitionManager.transition({appRoute: 'editRequestedAppointment'});
            };

            $scope.appointmentCheckIn = function appointmentCheckIn(appointment) {
                MyAppointmentsRepository
                    .changeAppointmentStatus(appointment.PatientId, appointment.AppointmentId, 'CD2A0578-0C89-4151-B4E9-66ED9D5B4995')
                    .then(function () {
                        getPatientAppointments($scope.searchFilter);
                        toaster.pop('success', '', gettext('Appointment check in is successful.'));
                        NotificationService.updateNotifications();
                    })
                    .catch(function () {
                        toaster.pop('error', '', gettext('An error occurred updating the appointment.'));
                    });
            };

            //$scope.appointmentCancel = function appointmentCancel(appointment) {
            //    alert('Cancel appointment not implemented, yet.  ' + appointment);
            //};

            $scope.loadMap = function toggleShow(appt){
               appt.mapLoaded = true;
            };

        }]);